import { CSSObject } from '@emotion/react'
import { fonts, fontSizes, fontWeights } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

const getTooltip = (isSmallBtn: boolean): CSSObject => ({
  'button.kuiper-disabled': {
    color: 'white',
    backgroundColor: colors.n9.base,
  },
  '.kuiper-input': {
    width: isSmallBtn ? '303px' : '266px',
  },
  '.kuiper-input-container': {
    height: '24px',
  },
  '.kuiper-input input[type=text], .kuiper-input-element': {
    height: 'unset',
  },
  'button.kuiper-refresh-button': {
    backgroundColor: colors.n7.base,
    color: colors.n4.base,
    borderRadius: '3px',
  },
})

const settingsWrapper: CSSObject = {
  width: '376px',
  backgroundColor: 'white',
  border: '2px solid white',
  fontFamily: fonts.proxima,
  fontWeight: fontWeights.bold,
  letterSpacing: 0,
  textTransform: 'uppercase',
  fontSize: fontSizes.caps.large,
  textAlign: 'left',
}

const titleSection: CSSObject = {
  padding: '16px 10px',
  margin: '0',
  color: colors.n3.base,
  fontFamily: fonts.proxima,
  fontWeight: fontWeights.bold,
  fontSize: fontSizes.caps.large,
  letterSpacing: 0,
}

const inputWrapper: CSSObject = {
  borderTop: '2px solid',
  borderColor: colors.n9.base,
  padding: '21px 10px 24px 10px',
  fontSize: fontSizes.caps.medium,
  fontWeight: fontWeights.bold,
  color: colors.n5.base,
}

const inputSection: CSSObject = {
  marginTop: '7px',
  display: 'flex',
  justifyContent: 'space-between',
}

const refreshSection: CSSObject = {
  fontFamily: fonts.sourceCode,
  fontSize: fontSizes.xxSmall,
  fontWeight: fontWeights.bold,
  color: colors.n6.base,
  marginTop: '4px',
  textTransform: 'none',
}

const refreshText: CSSObject = {
  fontFamily: fonts.sourceCode,
  fontSize: fontSizes.xxSmall,
  fontWeight: fontWeights.bold,
  color: colors.n6.base,
  textTransform: 'none',
}

const deleteSection: CSSObject = {
  padding: '6px 6px',
  display: 'flex',
  justifyContent: 'flex-end',
  backgroundColor: colors.n9.base,
  '.kuiper-icon-delete': {
    color: colors.n6.base,
  },
}

const settingsInput: CSSObject = {
  color: colors.n4.base,
  fontSize: fontSizes.small,
  fontFamily: fonts.proxima,
}

const styles = {
  getTooltip,
  settingsWrapper,
  titleSection,
  inputWrapper,
  inputSection,
  refreshSection,
  refreshText,
  deleteSection,
  settingsInput,
}

export { styles }
